import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Grid, Paper as MuiPaper } from "@material-ui/core";

const Paper = styled(MuiPaper)`
  height: 100%;
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
  justify-content: center;
`;

const Widget = ({ alignItems, children, ...other }) => {
  return (
    <Grid item {...other}>
      <Paper square alignItems={alignItems}>
        {children}
      </Paper>
    </Grid>
  );
};

Widget.defaultProps = {
  title: "",
  children: null,
  alignItems: "center"
};

Widget.propTypes = {
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
  alignItems: PropTypes.string
};

export default Widget;
